import z from "zod";

export const PaginationParamsDTO = z.object({
  pageIndex: z.coerce.number(),
  pageSize: z.coerce.number(),
});

export const SortParamsDTO = <T extends z.ZodEnum<any>>(columns: T) =>
  z
    .object({
      column: columns,
      order: z.enum(["asc", "desc"]),
    })
    .array()
    .default([]);
